function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "17",
  height: "17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h17v17H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.588 11.482a1.356 1.356 0 00-.256-.2l-2.125-1.267a1.47 1.47 0 00-1.794.227l-.482.488c-.04.04-.1.052-.152.03a.28.28 0 00-.226.513.7.7 0 00.777-.15l.481-.486a.91.91 0 011.109-.14l2.123 1.265a.787.787 0 01.144 1.235l-.333.341a3.681 3.681 0 01-3.999.806 12.711 12.711 0 01-4.22-2.8 12.71 12.71 0 01-2.8-4.22 3.68 3.68 0 01.804-3.997l.343-.336a.793.793 0 011.119.002.807.807 0 01.117.144l1.264 2.118a.91.91 0 01-.14 1.109l-.49.488a.702.702 0 00-.137.775 7.434 7.434 0 002.977 3.398.28.28 0 10.29-.48 6.876 6.876 0 01-2.756-3.148.136.136 0 01.024-.15l.489-.486a1.47 1.47 0 00.225-1.793L5.694 2.64a1.36 1.36 0 00-.2-.248 1.354 1.354 0 00-1.906-.001l-.344.337a4.241 4.241 0 00-.928 4.606 13.268 13.268 0 002.923 4.405 13.268 13.268 0 004.405 2.924 4.246 4.246 0 004.609-.931l.332-.341a1.352 1.352 0 00.003-1.91z",
  fill: "#54585D"
}))));